import React from 'react'

import { RenderMarkdown } from './render-markdown'

type MarkdownProps = {
  content: {
    title: string
    body: string
  }
}

const Markdown: React.FC<MarkdownProps> = ({ content }: MarkdownProps) => {
  return (
    <div className="col-span-2 flex flex-col gap-4">
      <div className="text-2xl font-semibold">{content.title}</div>
      <RenderMarkdown content={content?.body} />
    </div>
  )
}

export { Markdown }
